import { render, staticRenderFns } from "./addModal.vue?vue&type=template&id=5b9dc85c&scoped=true"
import script from "./addModal.vue?vue&type=script&lang=js"
export * from "./addModal.vue?vue&type=script&lang=js"
import style0 from "./addModal.vue?vue&type=style&index=0&id=5b9dc85c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9dc85c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b9dc85c')) {
      api.createRecord('5b9dc85c', component.options)
    } else {
      api.reload('5b9dc85c', component.options)
    }
    module.hot.accept("./addModal.vue?vue&type=template&id=5b9dc85c&scoped=true", function () {
      api.rerender('5b9dc85c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/dictionariesManage/addModal.vue"
export default component.exports